
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.091 13.65H8.66c2.085 0 3.404-1.1 3.404-2.788 0-1.333-.957-2.297-2.352-2.372v-.055c1.135-.157 1.908-1.012 1.908-2.099 0-1.524-1.162-2.46-3.063-2.46H5.091c-.731 0-1.155.43-1.155 1.182v7.417c0 .745.424 1.176 1.155 1.176zm1.1-5.714V5.482h1.683c.957 0 1.524.437 1.524 1.19 0 .792-.629 1.264-1.695 1.264H6.192zm0 4.136V9.358h1.717c1.203 0 1.866.465 1.866 1.34 0 .895-.643 1.374-1.818 1.374H6.192z","fill":"#000C1F"}})])
          )
        }
      }
    